/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Ask_User_Composer_BlockedInputs */



/**
* | output |
* | --- |
* | "Answer the question above to continue" |
*
* @param {Chat_Ask_User_Composer_BlockedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_ask_user_composer_blocked = /** @type {((inputs?: Chat_Ask_User_Composer_BlockedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Ask_User_Composer_BlockedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Beantworte die Frage oben, um fortzufahren")
	return /** @type {LocalizedString} */ ("Answer the question above to continue")
});